import React from 'react';
import ABDMEnrollemtStepBase from './EnrollmentStepBase'
import {Mode} from '../Helper/constants'
import {get_request_option} from '../Helper/helper'


export default class ABDMVerifyAadhaarOTP extends ABDMEnrollemtStepBase {

    constructor(props) {
        super(props);
        this.syncMessage();
        this.startOTPTimer();
        this._isMounted = false
    }

    state = {
        data : {
            otp: '',
            mobile: '',
        },
        message: '',
        error_message: '',
        errors: {},
        otp_resend_timer: 0,
        show_resend_button: false,
        otp_timer: 0,
        otp_request_in_progress : false,
        disable_resend_otp: false
    }

    syncMessage = () => {
        this.state = {
            ...this.state,
            message: this.props.message[this.getComponentStep()] || "",
            error_message: this.props.error_message[this.getComponentStep()] || "",
        };
    }

    validateInput = () => {
        this.state.errors.otp = this.state.data.otp.length !== 6 ? 'Please enter 6 digit OTP' : '';
        this.state.errors.mobile = this.state.data.mobile.length !== 10 ? 'Please enter 10 digit mobile number' : '';
    }

    handleResponse = (response) => {
        if(response.status === 200) {
            if(response.action == "verify_mobile") {
                // goto mobile verification step
                this.props.updateStep(3, response.message)
            } else {
                // goto abha address selection for old and new card both
                this.props.updateStep(4, '', '', response.suggestions)
            }
        } else if(response.status === 500) {
            this.props.updateStep(this.getComponentStep(), '', response.message)
        }
    }

    getEndpointUrl = () => {
        let url = '/dashboard/abdm/enroll/verify_otp'
        if(Mode.DEBUG) {
            url = Mode.TEST_HOST + url;
        }
        return url;
    }

    getRequestData = () => {
        let data = this.state.data;
        data.req_id = this.props.getReqId()
        return data
    }

    getComponentStep = () => {
        return 2
    }

    formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
    };

    handleChange = (e) => {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let name = target.name;
        this.setState({
            data:{
                ...this.state.data,
                [name]: value
            }
        });
    }

    startOTPTimer = () => {
        this.state.otp_resend_timer = 60;
        this.state.show_resend_button = false;
        this.state.disable_resend_otp = false;
        this.state.otp_timer = setInterval(() => {
            if(!this._isMounted) return;
            this.setState({
                otp_resend_timer: this.state.otp_resend_timer - 1
            })
            if(this.state.otp_resend_timer == 0) {
                clearInterval(this.state.otp_timer);
                this.setState({
                    show_resend_button: true,
                    otp_timer: 0
                })
            }
        }, 1000)
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        if (this.state.otp_timer) {
            clearInterval(this.state.otp_timer); // Clear the timer when unmounting
        }
        this._isMounted = false;
    }

    changeAadhaarNumber = () => {
        this.props.updateStep(1)
    }

    handleResendOTPRequest = (response) => {
        if(response.status === 200) {
            this.state.message = response.message;
            this.state.error_message = ''
            if( response.resend_allowed ) {
                this.startOTPTimer()
            } else {
                this.state.disable_resend_otp = true;
            }
        } else if(response.status === 500) {
            this.state.error_message = response.message;
            this.state.message = ''
        }
        this.setState({
            otp_request_in_progress: false
        })
    }

    getRequestOTPUrl = () => {
        let url = '/dashboard/abdm/enroll/request_otp'
        if(Mode.DEBUG) {
            url = Mode.TEST_HOST + url;
        }
        return url;
    }

    resendOTP = () => {
        this.setState({
            otp_request_in_progress: true
        })
        let data = this.props.shared_states[this.getComponentStep()];
        data.req_id = this.props.getReqId();
        let requestData = JSON.stringify(data);

        fetch(this.getRequestOTPUrl(), get_request_option("POST", requestData))
        .then(response => response.json())
        .then(data => {
            this.handleResendOTPRequest(data);
        }).catch( err => {
            console.log(err);
        });
    }

    render_internal = () => {
        return (
            <>
                <h1 className='mb-3'>Verify OTP</h1>

                {(this.state.message)?
                <div className='alert alert-success mb-3'>
                    {this.state.message}
                </div>:null}

                {(this.state.error_message)?
                <div className='alert alert-danger mb-3'>
                    {this.state.error_message}
                </div>:null}

                <div className="form-group">
                    <label className="control-label sr-only required" htmlFor="otp"></label>
                    <input id="otp" name="otp" type="number" placeholder="Enter the 6 digit OTP" className="form-control" onChange={this.handleChange} max={999999}/>
                    <p className='error_msg'>{this.state.errors.otp}</p>
                </div>

                <div className='mt-3 mb-3'>
                    {(this.state.otp_request_in_progress)?
                        <p className='btn'>Requesting OTP</p>
                    :
                        (this.state.show_resend_button)?
                            <button onClick={this.resendOTP} className='btn btn-light' disabled={this.state.disable_resend_otp}>Resend OTP</button>
                        :
                            <p className='btn'>Resend in {this.formatTime(this.state.otp_resend_timer)}</p>
                    }
                    | <button onClick={this.changeAadhaarNumber} className='btn'>Change aadhaar Number</button>
                </div>

                <div className="form-group mb-4">
                    <label className="control-label required ds_form_labels" htmlFor="Language">This mobile number will be used for all the communications</label>
                    <input id="mobile" name="mobile" type="number" placeholder="Enter your mobile number" className="form-control" value={this.state.mobile} onChange={this.handleChange} min={0} style={{marginTop:"0px"}}/>
                    <p className='error_msg'>{this.state.errors.mobile}</p>
                </div>

                <button className="btn btn-primary btn-block w-100 btn-block" onClick={this.submitRequest}>Submit OTP</button>
            </>
        )
    }
}